module.exports = __webpack_public_path__ + "img/outline-life-black.b7feb1f.svg";